import Banner from '../comps/Banner';
import HighlightsA from '../compsJp/HighlightsA';
import ListA from '../compsJp/ListA';
import ListB from '../compsJp/ListB';
import P from '../compsJp/P';
import SectionA from '../compsJp/SectionA';
import SectionB from '../compsJp/SectionB';
import SectionC from '../compsJp/SectionC';
import SectionD from '../compsJp/SectionD';
import SectionE from '../compsJp/SectionE';
import SectionF from '../compsJp/SectionF';
import TabA from '../compsJp/TabA';
import WhatInBox from '../compsJp/WhatInBox';
import FootTC from '../compsJp/FootTC';
import styles from './ProductContent.module.scss';

export default function ProductJp({ bundles, callbackCart }: any) {
    return (
        <div className={styles.teaser}>
            <Banner />
            <HighlightsA />
            <SectionA />
            <SectionB />
            <SectionC />
            <SectionD />
            <SectionE />
            <TabA />
            <SectionF />
            <ListA />

            <ListB />
            <WhatInBox />
            <P bundles={bundles} callbackCart={callbackCart} />
            <FootTC />
        </div>
    );
}
